import { fromPythonTS } from 'utils/time'

import {
    STRONGHOLD_MANEUVERS_REQUEST,
    STRONGHOLD_MANEUVERS_SUCCESS,
    STRONGHOLD_MANEUVERS_ERROR,
} from 'state/actions/stronghold_maneuvers'

export const initialState = {
    loading: false,
    loaded: false,
    error: false,
    sprintConfig: {
        sprintStartDate: 0,
        sprintEndDate: 0,
        sprintNumber: 0,
        sprintType: '',
    },
    visibleStartDate: 0,
    visibleEndDate: 0,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case STRONGHOLD_MANEUVERS_REQUEST:
        return {
            ...state,
            loading: true,
            error: false,
        }
    case STRONGHOLD_MANEUVERS_SUCCESS: {
        const { event_config } = action.payload
        const { visible_start_date, visible_end_date, sprint_config } = (event_config || {})

        return {
            ...state,
            sprintConfig: {
                sprintStartDate: fromPythonTS(sprint_config.sprint_start_date),
                sprintEndDate: fromPythonTS(sprint_config.sprint_end_date),
                sprintNumber: sprint_config.sprint_number,
                sprintType: sprint_config.sprint_type,
            },
            visibleStartDate: fromPythonTS(visible_start_date),
            visibleEndDate: fromPythonTS(visible_end_date),
            loaded: true,
            loading: false,
            error: false,
        }
    }
    case STRONGHOLD_MANEUVERS_ERROR:
        return {
            ...state,
            error: true,
            loading: false,
            loaded: true,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/stronghold_maneuvers.js